import { createSlice } from '@reduxjs/toolkit';

const elementsOptions = [
];

const partNumberSuggestions = [
];

const ssrDescriptionSlice = createSlice({
  name: 'ssrDescription',
  initialState: {
    partNumberSuggestions,
    elementsOptions,
  },
  reducers: {
    handleAddNewElement: (state, action) => {
     
      state.elementsOptions = [...state.elementsOptions, action.payload];
      state.partNumberSuggestions = [
        ...state.partNumberSuggestions,
        action.payload.partNumber,
      ];
    },
    handleAddNewElements: (state, action) => {
      state.elementsOptions = action.payload.reduce((result, item) => {
        if (elementsOptions.find(spec => spec.partNumber === item.partNumber) === undefined) {
          return [item, ...result];
        } else {
          return result;
        }
      }, elementsOptions);
      state.partNumberSuggestions = [...new Set([
        ...state.partNumberSuggestions,
        ...action.payload.map((element) => element.partNumber),
      ])];
    },
  },
});

export default ssrDescriptionSlice;
export const selectDescription = (state) => state.ssrDescription;
export const { handleAddNewElement, handleAddNewElements } = ssrDescriptionSlice.actions;
